/** Query Key Factory — domínio Admin */

export const userKeys = {
  all: ["users"] as const,
  me: () => [...userKeys.all, "me"] as const,
  assignees: () => [...userKeys.all, "assignees"] as const,
  firebaseUnlinked: () => [...userKeys.all, "firebase-unlinked"] as const,
};

export const roleKeys = {
  all: ["roles"] as const,
};

export const auditKeys = {
  all: ["audit"] as const,
  list: (params?: Record<string, unknown>) =>
    [...auditKeys.all, "list", { params }] as const,
};

export const importKeys = {
  batches: ["import-batches"] as const,
  batchList: (params?: Record<string, unknown>) =>
    [...importKeys.batches, "list", { params }] as const,
  batchErrors: (batchId: string | null) =>
    ["import-batch-errors", batchId] as const,
};

export const aiAssistantKeys = {
  all: ["ai-assistants"] as const,
  me: () => [...aiAssistantKeys.all, "me"] as const,
  detail: (id: number | undefined) => [...aiAssistantKeys.all, id] as const,
  assignments: (assistantId: number | undefined) =>
    [...aiAssistantKeys.all, assistantId, "assignments"] as const,
  messages: (
    assistantId: number | undefined,
    params?: { user_id?: string; skip?: number; limit?: number }
  ) => [...aiAssistantKeys.all, assistantId, "messages", params] as const,
  costs: (assistantId: number | undefined) =>
    [...aiAssistantKeys.all, assistantId, "costs"] as const,
};

export const permissionKeys = {
  byUser: (userId: string | null | undefined) =>
    ["resource_permissions", userId] as const,
};
